import { render } from "./DepartmentModal.vue?vue&type=template&id=332fbb46&scoped=true"
import script from "./DepartmentModal.vue?vue&type=script&lang=js"
export * from "./DepartmentModal.vue?vue&type=script&lang=js"

import "./DepartmentModal.vue?vue&type=style&index=0&id=332fbb46&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-332fbb46"]])

export default __exports__